import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'Trucks'
const DB_VERSION = 1
const STORE_NAME = 'Machines'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_NAME, keyPath: 'id' }
])

const initDbMachines = () => {
    return dbInstance.init()
}

const agregar = (data, database) => {
    return dbInstance.add(STORE_NAME, data, database)
}

const obtener = (clave, database) => {
    return dbInstance.get(STORE_NAME, clave, database)
}

const actualizar = (data, database) => {
    return dbInstance.put(STORE_NAME, data, database)
}

const eliminar = (clave, database) => {
    return dbInstance.delete(STORE_NAME, clave, database)
}

const consultar = (database) => {
    return dbInstance.getAll(STORE_NAME, database)
}

export default {
    initDbMachines,
    agregar,
    obtener,
    actualizar,
    eliminar,
    consultar
}
